import { useLocation, type To } from 'react-router';

type ListLocationState = { from?: string } | null;

/**
 * Resolves where a back link should go: the list url the user came from when it
 * was handed over through the navigation state, the given fallback otherwise
 * (direct link, page reload).
 */
export const useBackTo = (fallback: To): To => {
  const { state } = useLocation();
  return (state as ListLocationState)?.from ?? fallback;
};
